export default function Result() {
  return {}
}
